/**
 * 指定ミリ秒待機する Promise ユーティリティ。
 * @param {number} ms 待機時間 (ms)
 * @returns {Promise<void>}
 */
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
